import classNames from 'classnames';
import { Component } from 'react';

import FormError from './FormError';

class SelectField extends Component {
  // This isn't a pure function because focusing on a form field requires a ref (search code base for withRef)
  render() {
    const {
      input,
      label,
      meta: { touched, error },
      optionArray,
      className,
      labelClassName,
      autocomplete,
      refField,
      required
    } = this.props;
    const id = `c7-${input.name}`;
    let describedBy;
    if (touched && error) {
      describedBy = {
        'aria-describedby': `${id}-error`,
        'aria-invalid': 'true'
      };
    }
    return (
      <div
        className={classNames(
          'c7-selectbox',
          className,
          touched && error && 'c7-error'
        )}
      >
        <label className={labelClassName} htmlFor={`c7-${input.name}`}>
          {/* required && '*' */}
          {label} {!required && <span className="c7-optional">(optional)</span>}
          <span className="c7-selectboxWrap">
            <select
              id={id}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...input}
              ref={refField}
              value={
                input.value || optionArray.length === 0
                  ? input.value
                  : optionArray[0].value
              }
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...describedBy}
              autoComplete={autocomplete}
            >
              {renderSelectOptions(optionArray)}
            </select>
          </span>
        </label>
        <FormError touched={touched} error={error} id={`${id}-error`} />
      </div>
    );
  }
}

const renderSelectOptions = (optionArray) =>
  optionArray.map((option) => (
    <option value={option.value} key={option.value}>
      {option.option}
    </option>
  ));

export default SelectField;
